var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showOnRequiresAuth)?_c('SideNav',{attrs:{"temp":_vm.showTempSideNav}}):_vm._e(),_c('v-main',[_c('router-view'),_c('global-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }